import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCubeRotation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3 26c.72 7.52 5.4 13.88 11.94 16.96l2.66-2.64 7.62 7.62-1.32.06C11.32 48 1.02 38.32 0 26zM22.58.06 23.9 0c12.58 0 22.88 9.68 23.88 21.98h-3c-.7-7.52-5.38-13.86-11.92-16.96L30.2 7.68zm-8.298 30.873 8.32 4.882q.616.366 1.314.366t1.328-.366l8.435-4.882A2.61 2.61 0 0 0 35 28.647v-9.745a2.64 2.64 0 0 0-1.282-2.285l-8.358-4.96A2.67 2.67 0 0 0 24 11.3a2.67 2.67 0 0 0-1.36.357l-8.358 4.96q-.607.372-.945.972T13 18.902v9.745q0 .717.337 1.32.338.601.945.966m8.555-6.515v8.434L15.68 28.55v-8.252zm9.52 4.133-7.193 4.3v-8.433l7.194-4.12zm-1.201-10.386L24 22.32l-7.155-4.155L24 14.06z" })
});
export default SvgCubeRotation;
